module.exports = __webpack_public_path__ + "static/media/icon_menu_close.376f59e9.svg";